import { FeedbackType } from '@chegg-wt/core-wa/types'

export const UnderlineStyles = {
  BORDER_BOTTOM: 'border-bottom: 2px solid red',
  PADDING_BOTTOM: 'padding-bottom: 4px',
}

export const UnderlineColors = {
  [FeedbackType.GRAMMAR]: '#4dae9a',
  [FeedbackType.PARAPHRASE]: '#40739d',
}
